/**
 * TNF – VECTIV Landing – Carousel & interactions
 */
(function () {
  'use strict';

  function getVectivAdjacentBanner(vectivRoot) {
    if (!(vectivRoot instanceof Element)) return null;
    var vectivSection = vectivRoot.closest('.shopify-section');
    if (!vectivSection) return null;
    var bannerSection = vectivSection.previousElementSibling;
    if (!(bannerSection instanceof Element) || !bannerSection.classList.contains('shopify-section')) return null;
    return bannerSection.querySelector('.tnf-media-banner');
  }

  function getPlainText(element) {
    if (!element) return '';
    return (element.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function getExcerpt(text) {
    if (!text) return '';
    if (text.length <= 110) return text;
    return text.slice(0, 107).trim() + '...';
  }

  function initVectivMobileBanner(root) {
    var vectivSections = [];

    if (root instanceof Element && root.matches('.tnf-vectiv')) {
      vectivSections.push(root);
    }

    if ('querySelectorAll' in root) {
      root.querySelectorAll('.tnf-vectiv').forEach(function (vectivElement) {
        vectivSections.push(/** @type {HTMLElement} */ (vectivElement));
      });
    }

    vectivSections.forEach(function (vectivRoot) {
      if (vectivRoot.hasAttribute('data-vectiv-mobile-banner-initialized')) return;
      vectivRoot.setAttribute('data-vectiv-mobile-banner-initialized', 'true');

      var banner = getVectivAdjacentBanner(vectivRoot);
      if (!(banner instanceof HTMLElement)) return;
      if (banner.classList.contains('tnf-media-banner--vectiv-mobile-hero')) return;
      if (banner.hasAttribute('data-vectiv-mobile-hero-ready')) return;

      var introPanel = vectivRoot.querySelector('.tnf-vectiv__panel--intro');
      if (!(introPanel instanceof Element)) return;

      var heading = getPlainText(introPanel.querySelector('.tnf-vectiv__intro-heading'));
      var description = getExcerpt(getPlainText(introPanel.querySelector('.tnf-vectiv__intro-desc')));
      var logo = /** @type {HTMLImageElement | null} */ (introPanel.querySelector('.tnf-vectiv__intro-logo-img'));
      var cta = /** @type {HTMLAnchorElement | null} */ (vectivRoot.querySelector('.tnf-vectiv__panel--cta .tnf-vectiv__cta-btn'));

      var overlay = document.createElement('div');
      overlay.className = 'tnf-media-banner__vectiv-mobile-overlay';

      var pattern = document.createElement('div');
      pattern.className = 'tnf-media-banner__vectiv-mobile-pattern';
      overlay.appendChild(pattern);

      var content = document.createElement('div');
      content.className = 'tnf-media-banner__vectiv-mobile-content';

      if (heading) {
        var title = document.createElement('h2');
        title.className = 'tnf-media-banner__vectiv-mobile-title';
        title.textContent = heading;
        content.appendChild(title);
      }

      if (logo && logo.currentSrc) {
        var logoImage = document.createElement('img');
        logoImage.className = 'tnf-media-banner__vectiv-mobile-logo';
        logoImage.src = logo.currentSrc;
        logoImage.alt = logo.alt || 'VECTIV';
        content.appendChild(logoImage);
      }

      if (description) {
        var body = document.createElement('p');
        body.className = 'tnf-media-banner__vectiv-mobile-body';
        body.textContent = description;
        content.appendChild(body);
      }

      if (cta) {
        var button = document.createElement('a');
        button.className = 'tnf-media-banner__vectiv-mobile-cta';
        button.href = cta.href;
        button.textContent = getPlainText(cta) || 'Conoce mas';
        content.appendChild(button);
      }

      overlay.appendChild(content);
      banner.appendChild(overlay);
      banner.setAttribute('data-vectiv-mobile-hero-ready', 'true');
    });
  }

  /**
   * @param {ParentNode | Element | Document} root
   */
  function initVectivCarousels(root) {
    var carousels = [];

    if (root instanceof Element && root.matches('[data-vectiv-carousel]')) {
      carousels.push(root);
    }

    if ('querySelectorAll' in root) {
      root.querySelectorAll('[data-vectiv-carousel]').forEach(function (carouselElement) {
        carousels.push(/** @type {HTMLElement} */ (carouselElement));
      });
    }

    carousels.forEach(function (carousel) {
      if (carousel.hasAttribute('data-vectiv-initialized')) return;
      carousel.setAttribute('data-vectiv-initialized', 'true');

      var track = carousel.matches('[data-vectiv-track]')
        ? carousel
        : /** @type {HTMLElement | null} */ (carousel.querySelector('[data-vectiv-track]'));
      var prevBtn = /** @type {HTMLButtonElement | null} */ (carousel.querySelector('[data-vectiv-prev]'));
      var nextBtn = /** @type {HTMLButtonElement | null} */ (carousel.querySelector('[data-vectiv-next]'));
      var carouselShell = carousel.closest('[data-vectiv-carousel-shell]');
      var dotsWrap = carouselShell
        ? /** @type {HTMLElement | null} */ (carouselShell.querySelector('[data-vectiv-dots]'))
        : null;

      if (!track) return;
      var trackEl = track;

      function getScrollAmount() {
        var firstSlide = /** @type {HTMLElement | null} */ (trackEl.firstElementChild);
        if (!firstSlide) return trackEl.clientWidth;
        var style = getComputedStyle(trackEl);
        var gap = parseInt(style.gap, 10) || 20;
        return firstSlide.offsetWidth + gap;
      }

      function updateNav() {
        if (prevBtn) prevBtn.disabled = trackEl.scrollLeft <= 1;
        if (nextBtn) nextBtn.disabled = trackEl.scrollLeft + trackEl.clientWidth >= trackEl.scrollWidth - 1;
      }

      function renderDots() {
        if (!dotsWrap) return;
        var scrollAmount = getScrollAmount();
        var pages = Math.max(1, Math.round((trackEl.scrollWidth - trackEl.clientWidth) / scrollAmount) + 1);
        if (pages <= 1) {
          dotsWrap.innerHTML = '';
          return;
        }
        var currentPage = Math.min(pages - 1, Math.round(trackEl.scrollLeft / scrollAmount));
        var html = '';
        for (var i = 0; i < pages; i++) {
          html +=
            '<button type="button" class="tnf-vectiv__dot' +
            (i === currentPage ? ' tnf-vectiv__dot--active' : '') +
            '" data-page="' + i + '" aria-label="Página ' + (i + 1) + '"></button>';
        }
        dotsWrap.innerHTML = html;

        dotsWrap.querySelectorAll('.tnf-vectiv__dot').forEach(function (dotElement) {
          var dot = /** @type {HTMLButtonElement} */ (dotElement);
          dot.addEventListener('click', function () {
            var page = parseInt(dot.dataset.page || '0', 10);
            trackEl.scrollTo({ left: scrollAmount * page, behavior: 'smooth' });
          });
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          trackEl.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          trackEl.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        });
      }

      /** @type {number | undefined} */
      var scrollTimer;
      trackEl.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          updateNav();
          renderDots();
        }, 60);
      }, { passive: true });

      updateNav();
      renderDots();

      /** @type {number | undefined} */
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          updateNav();
          renderDots();
        }, 150);
      });
    });
  }

  function boot() {
    initVectivMobileBanner(document);
    initVectivCarousels(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initVectivMobileBanner(/** @type {Element} */ (event.target));
    initVectivCarousels(/** @type {Element} */ (event.target));
  });

  document.addEventListener('shopify:section:reorder', function (event) {
    initVectivMobileBanner(/** @type {Element} */ (event.target));
    initVectivCarousels(/** @type {Element} */ (event.target));
  });

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;
        initVectivMobileBanner(node);
        initVectivCarousels(node);
      });
    });
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
    }, { once: true });
  }
})();
